import React, { useEffect, useContext, useState } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import JSZip from "jszip";
import FileSaver from "file-saver";
import Dropdown from 'react-bootstrap/Dropdown';
import { Table, Tooltip, Radio, Select, Col, Row, Pagination, Input, Button } from 'antd';
import columnIcon from '../assets/images/icons/column.svg'
import imIcon from '../assets/images/icons/skype.svg';
import crossIcon from '../assets/images/icons/cross.svg';
import telegramIcon from '../assets/images/icons/telegram.svg';
import wechatIcon from '../assets/images/icons/wechat.svg';
import checkIcon from '../assets/images/icons/check.svg';
import mediaKitIcon from '../assets/images/icons/download.svg';
import mediaKitIcon2 from '../assets/images/icons/export_download_icon.svg';
import { saveAs } from "file-saver";
import { Link } from 'react-router-dom'
import FullLoader from "../assets/images/full-page-loader.gif"
import prevIcon from '../assets/images/icons/chevron-left.svg';
import nextIcon from '../assets/images/icons/chevron-right.svg';
import noData from '../assets/images/data-graph/no-data.svg';
import importIcon from '../assets/images/icons/import.svg';
import errorData from '../assets/images/data-graph/error-data.svg';
import loaderIcon from "../assets/images/login-and-signup/loader.gif";
import partialDataIcon from '../assets/images/icons/parital_data_icon.svg';
import timeDataIcon from '../assets/images/icons/time_data_icon.svg';

import TableLoader from "./TableLoader";
import PublisherImport from "./PublisherImport";
import PublisherViewEdit from "./PublisherViewEdit";

const PublisherListing = () => {
  const loadingContext = useContext(LoadingContext);
  const [apiCall, setApicall] = useState(false)
  const [pageView, setPageView] = useState("table")
  const [publisherViewId, setPublisherViewId] = useState("")
  const [publisherViewName, setPublisherViewName] = useState("")
  const [accountStatus, setAccountStatus] = useState("")
  const [columnPartialData, setColumnPartialData] = useState(false)
  const [columnTimeData, setColumnTimeData] = useState("")

  const [colvis, setColvis] = useState({
    // "Name": true,
    // "Organization Name": true,
    // "Email": true,
    "Website": true,
    "IM": true,
    "Phone Number": true,
    "Country": true,
    "zone": true,
    "AM": true,
    "Seller Type": true,
    "GAM Integration": true,
    "Media Kit": true,
    "ADK ID": true,
    "Aniview ID": true,
    "GAM ID": true,
    "impressions": true,
    "givtImpressions": true,
    "sivtImpressions": true,
    "givtSivtImp": true,
    "viewability": true,
    "discrep": true,
    "pix_updatedAt": true,
  })

  const exportHeader =
    [
      {
        label: "Status",
        key: "Status",
      },
      {
        label: "Name",
        key: "Name",
      },
      {
        label: "Organization Name",
        key: "Organization Name",
      },
      {
        label: "Email",
        key: "Email",
      },
      {
        label: "Website",
        key: "Website",
      },
      {
        label: "IM",
        key: "IM",
      },
      {
        label: "Phone Number",
        key: "Phone Number",
      },
      {
        label: "Country",
        key: "Country",
      },
      {
        label: "Zones",
        key: "zone",
      },
      {
        label: "AM",
        key: "AM",
      },
      {
        label: "Seller Type",
        key: "Seller Type",
      },
      {
        label: "GAM Integration",
        key: "GAM Integration",
      },
      {
        label: "ADK ID",
        key: "ADK ID",
      },
      {
        label: "Aniview ID",
        key: "Aniview ID",
      },
      {
        label: "GAM ID",
        key: "GAM ID",
      },
      {
        label: " Gross Ad Count",
        key: "impressions",
      },
      {
        label: "GIVT Ad Count",
        key: "givtImpressions",
      },
      {
        label: "SIVT Ad Count",
        key: "sivtImpressions",
      },
      {
        label: "IVT",
        key: "givtSivtImp",
      },
      {
        label: "Net Viewability",
        key: "viewability",
      },
      {
        label: "Discrepancies",
        key: "discrep",
      },
      {
        label: "Updated At (UTC)",
        key: "pix_updatedAt",
      },

    ]

  const [exportLoading, setExportLoading] = useState(false)

  function addCommasToNumber(num) {
    const isDecimal = num % 1 !== 0;
    let numStr = num.toString();
    let [wholePart, decimalPart] = numStr.split(".");
    wholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (isDecimal) {
      numStr = `${wholePart}.${decimalPart}`;
    } else {
      numStr = wholePart;
    }

    return numStr;
  }

  const columnsAll = [
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      // render: (data) => <div className='badge_content--approved'>{data}</div>,
      fixed: 'left',
      width: 120,
      render: (text, record) => <div className='w_100 position-relative'>
        <Select
          className={`form_select badge_content--${text?.toLowerCase()}`}
          dropdownStyle={{
            width: '12rem'
          }}
          value={text === "New" ? "New" : text?.toLowerCase()}

          options={text === "New" ?
            [{ label: "Verified", value: "verified" }, { label: "Declined", value: "declined" }] :
            text === "Verified" && record?.Onboarding < 2 ?
              [{ label: "Verified", value: "verified" }, { label: "Declined", value: "declined" }] :
              text === "Verified" && record?.Onboarding === 2 ?
                [{ label: "Approved", value: "approved" }, { label: "Verified", value: "verified" }, { label: "Declined", value: "declined" }] :
                text === "Declined" && record?.Onboarding < 2 ?
                  [{ label: "Declined", value: "declined" }, { label: "Verified", value: "verified" }] :
                  text === "Declined" && record?.Onboarding === 2 && record?.approvedOnce === false ?
                    [{ label: "Declined", value: "declined" }, { label: "Verified", value: "verified" }, { label: "Approved", value: "approved" }] :
                    [{ label: "Declined", value: "declined" }, { label: "Approved", value: "approved" }]
          }
          onChange={(event) => {

            // if (event.toLowerCase() !== text.toLowerCase()) {

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              let token = Cookies.get("token_xapads_ssp");

              let payload = {
                "status": event,
                "_id": record?._id,
                "approvedOnce": record?.approvedOnce
              }

              setLoading(true)
              axios
                .post(configData.SERVER_URL + `ops/statusUpdate`, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  setApicall(!apiCall)
                  notifysuccess(response.data.message);

                })
                .catch((error) => {
                  if (error.response.data.message?.length !== 0) {
                    notifyfailure(error.response.data.message)
                  }
                  else {
                    notifycatch()
                  }
                  setLoading(false)

                });

            }
            // }
          }
          }
        />
      </div>,

    },


    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      width: 160,
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}

      >{data}</div>,
      // width: 220,
    },
    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 200,
      key: "Organization Name",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      // width: 250,
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sortOrder: sort.name === 'Email' ? sort.type : null,
      render: (data) => <Tooltip title={data}><div className='text_dark text_ellipsis'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      width: 200,
      key: "Website",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["Website"],
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      // width: 200,
      key: "IM.value",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["IM"],
      // sorter: true,
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            < img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    {
      title: "Phone Number",
      dataIndex: "Phone Number",
      width: 170,
      key: "Phone Number",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["Phone Number"],
      // sorter: true,
      render: (text) => {
        return (<>
          {(text === "" || text === undefined || text === null) ? <><div className='text_dark'>-</div></> : <div className='text_dark'>{text}</div>}
        </>
        )
      }

    },

    {
      title: "Country",
      dataIndex: "Country",
      width: 100,
      key: "Country",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["Country"],
      render: (text, record) => {
        return (
          <>{
            text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
              <Tooltip title={record.countryName}> <div><img src={text} alt={text} className="flag_icon" /></div></Tooltip>
          }
          </>
        )
      },
    },
    {
      title: "Zones",
      dataIndex: "zone",
      width: 80,
      key: "zone",
      hidden: !colvis["zone"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (data, record) => <div className='text_dark'>
        {record.Status === "Approved" && data === 0 ?
          <Link className="zero_value_design2" style={{ textDecoration: "none", cursor: "default" }} >{data}</Link> :
          record.Status === "Approved" && data !== 0 ?
            <Link to={`/zoneList?publisher=${record["ADK ID"]}-${record["Name"]}`} target="_blank" className='text_primary back_area_increase_d2'>{data}</Link>
            : <div className='text_dark back_area_increase_d2'>-</div>}
      </div>,
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      key: "AM",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["AM"],
      // sorter: true,
      // width: 150,
      render: (text, record) => {
        let data = Array.isArray(text) ? text?.length > 0 ? text[0] : "" : ""
        return (
          <div className='w_100 position-relative'>
            <Select
              value={data}
              className={data === "" ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              // className='form_select tag_content--add' //--add  //--badge-grey

              dropdownStyle={{
                width: '22rem' // this code by ajay
                // width: auto // this code by tej
              }}
              options={accountManagerOptions}
              onChange={(event) => {

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");

                  let payload = {
                    "am": [event],
                  }

                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);

                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)

                    });

                }
              }
              }
            />
          </div>
        )
      }

    },
    {
      title: "Seller Type",
      dataIndex: "Seller Type",
      width: 133,
      key: "Seller Type",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["Seller Type"],
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <div className='tag_content--group'><div className='tag_content--grey'>{text}</div></div>}
          </>
        )
      }

    },
    {
      title: "GAM Integration",
      dataIndex: "GAM Integration",
      width: 120,
      key: "GAM Integration",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["GAM Integration"],
      // sorter: true,
      render: (text) => <div className='text_dark'>{text}</div>,
    },
    {
      title: "Media Kit",
      width: 80,
      key: "mediaKit",
      hidden: !colvis["Media Kit"],
      render: (_, record) => {
        return (
          record?.Onboarding === 2 && record["Media Kit"]?.length > 0 ?
            <button className='download_icon download_icon_d2'
              onClick={() => {
                fetchAndDownloadFiles(
                  record["Media Kit"],
                  // cell.row.original["title"],
                  // cell.row.original["trackierCampaignId"]
                )

              }}
            ><img src={mediaKitIcon} alt='USP' /></button>
            : <><div className='text_dark'>-</div></>
        )
      }
    },
    {
      title: "ADK ID",
      dataIndex: "ADK ID",
      width: 90,
      key: "ADK ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["ADK ID"],
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "Aniview ID",
      dataIndex: "Aniview ID",
      width: 230,
      key: "Aniview ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["Aniview ID"],
      sorter: true,
      render: (text, record) => {
        return (
          <>
            {(text === "" || text === null || text === undefined) && record.Status === "Approved" ?
              <>
                <div className='text_dark'>
                  {record?.aniviewLoading ?

                    <button className="new_integrate_btn_d2 btn btn_primary loader loader_btn_with_icon">
                      <span> Integrate</span>
                      <img src={FullLoader} alt="USP" className="" />
                    </button>
                    :
                    <button className="new_integrate_btn_d2" onClick={() => { handleAniviewIdCreate(record) }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M7.5 5L10 7.5L7.5 10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2 2V5.5C2 6.03043 2.21071 6.53914 2.58579 6.91421C2.96086 7.28929 3.46957 7.5 4 7.5H10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Integrate
                    </button>
                  }
                </div>
              </>
              :
              (text === "" || text === null || text === undefined) && record.Status !== "Approved" ?
                <><div className='text_dark'>-</div></>
                :
                <>
                  {text}
                </>}
          </>
        )
      }
    },
    {
      title: "GAM ID",
      dataIndex: "GAM ID",
      width: 120,
      key: "GAM ID",
      hidden: !colvis["GAM ID"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },

    {
      title:
        <>

          <span >
            Gross Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :

              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "impressions",
      width: 170,
      key: "impressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["impressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            GIVT Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>

              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "givtImpressions",
      width: 170,
      key: "givtImpressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["givtImpressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtImpsRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            SIVT Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "sivtImpressions",
      width: 170,
      key: "sivtImpressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["sivtImpressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.sivtImpsRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title: <>

        <span >
          IVT
          {columnPartialData ?
            <Tooltip
              title={`Partial Data (${columnTimeData})`}
            >
              <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
            </Tooltip>
            :
            <Tooltip
              title={`Complete Data (${columnTimeData})`}
            >
              <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
            </Tooltip>
          }
        </span>


      </>,
      dataIndex: "givtSivtImp",
      width: 160,
      key: "givtSivtImp",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["givtSivtImp"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtSivtRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            Net Viewability
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>



        </>,
      dataIndex: "viewability",
      width: 150,
      key: "viewability",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["viewability"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)} %
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            Discrepancies
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>

              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>

        </>,
      dataIndex: "discrep",
      width: 150,
      key: "discrep",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["discrep"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
              </>
            }
          </>
        )
      },
    },
    {
      title: "Updated At (UTC)",
      dataIndex: "pix_updatedAt",
      width: 150,
      key: "pix_updatedAt",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["pix_updatedAt"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {data}
              </>
            }
          </>
        )
      },
    },

  ];

  const columnsNew = [
    {
      title: "Action",
      key: "action",
      // render: (data) => <div className='badge_content--approved'>{data}</div>,
      fixed: 'left',
      width: 200,
      render: (_, record) => <div className='btn_group'>
        <button className='btn_outline_success btn' onClick={() => { statusChange("verified", record._id, record.approvedOnce) }}><img src={checkIcon} alt='USP' /> Verify</button>
        <button className='btn_outline_danger btn' onClick={() => { statusChange("declined", record._id, record.approvedOnce) }}><img src={crossIcon} alt='USP' /> Decline</button>
      </div>,

    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}

      >{data}</div>,
      // width: 220,
    },
    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 200,
      key: "Organization Name",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      // width: 200,
      sorter: true,

      sortDirections: ['ascend', 'descend', 'ascend'],
      // sortOrder: sort.name === 'Email' ? sort.type : null,
      render: (data) => <Tooltip title={data}><div className='text_dark text_ellipsis'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      // width: 200,
      key: "Website",
      hidden: !colvis["Website"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      // width: 200,
      key: "IM.value",
      hidden: !colvis["IM"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            <img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      key: "AM",
      hidden: !colvis["AM"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      // width: 150,
      render: (text, record) => {
        let data = Array.isArray(text) ? text?.length > 0 ? text[0] : "" : ""
        return (
          <div className='w_100 position-relative'>
            <Select
              value={data}
              className={data === "" ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              // className='form_select tag_content--add' //--add  //--badge-grey

              dropdownStyle={{
                width: '22rem'
              }}
              options={accountManagerOptions}
              onChange={(event) => {

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");

                  let payload = {
                    "am": [event],
                  }

                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);

                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)

                    });

                }
              }
              }
            />
          </div>
        )
      }

    },


    {
      title:
        <>

          <span >
            Gross Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :

              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "impressions",
      width: 170,
      key: "impressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["impressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            GIVT Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>

              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "givtImpressions",
      width: 170,
      key: "givtImpressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["givtImpressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtImpsRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            SIVT Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "sivtImpressions",
      width: 170,
      key: "sivtImpressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["sivtImpressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.sivtImpsRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title: <>

        <span >
          IVT
          {columnPartialData ?
            <Tooltip
              title={`Partial Data (${columnTimeData})`}
            >
              <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
            </Tooltip>
            :
            <Tooltip
              title={`Complete Data (${columnTimeData})`}
            >
              <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
            </Tooltip>
          }
        </span>


      </>,
      dataIndex: "givtSivtImp",
      width: 160,
      key: "givtSivtImp",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["givtSivtImp"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtSivtRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            Net Viewability
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>



        </>,
      dataIndex: "viewability",
      width: 150,
      key: "viewability",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["viewability"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)} %
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            Discrepancies
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>

              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>

        </>,
      dataIndex: "discrep",
      width: 150,
      key: "discrep",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["discrep"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
              </>
            }
          </>
        )
      },
    },
    {
      title: "Updated At (UTC)",
      dataIndex: "pix_updatedAt",
      width: 150,
      key: "pix_updatedAt",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["pix_updatedAt"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {data}
              </>
            }
          </>
        )
      },
    },

  ];
  const columnsVerified = [
    {
      title: "Action",
      key: "action",
      // render: (data) => <div className='badge_content--approved'>{data}</div>,
      fixed: 'left',
      width: 200,
      render: (_, record) => <div className='btn_group'>
        <button className='btn_outline_success btn' disabled={record.Onboarding === 2 ? false : true} onClick={() => { statusChange("approved", record._id, record.approvedOnce) }}><img src={checkIcon} alt='USP' /> Approve</button>
        <button className='btn_outline_danger btn' onClick={() => { statusChange("declined", record._id, record.approvedOnce) }}><img src={crossIcon} alt='USP' /> Decline</button>
      </div>,

    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}

      >{data}</div>,
      // width: 220,
    },
    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 200,
      key: "Organization Name",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      // width: 200,
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sortOrder: sort.name === 'Email' ? sort.type : null,
      render: (data) => <Tooltip title={data}><div className='text_dark text_ellipsis'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      // width: 200,
      key: "Website",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["Website"],
      sorter: true,
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      // width: 200,
      key: "IM.value",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["IM"],
      // sorter: true,
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            <img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    {
      title: "Phone Number",
      dataIndex: "Phone Number",
      width: 170,
      key: "Phone Number",
      hidden: !colvis["Phone Number"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => {
        return (<>
          {(text === "" || text === undefined || text === null) ? <><div className='text_dark'>-</div></> : <div className='text_dark'>{text}</div>}
        </>
        )
      }

    },
    {
      title: "Country",
      dataIndex: "Country",
      width: 100,
      key: "Country",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["Country"],
      sorter: true,
      render: (text, record) => {
        return (
          <>{
            text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
              <Tooltip title={record.countryName}> <div><img src={text} alt={text} className="flag_icon" /></div></Tooltip>
          }
          </>
        )
      },
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      key: "AM",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["AM"],
      // sorter: true,
      // width: 150,
      render: (text, record) => {
        let data = Array.isArray(text) ? text?.length > 0 ? text[0] : "" : ""
        return (
          <div className='w_100 position-relative'>
            <Select
              value={data}
              className={data === "" ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              // className='form_select tag_content--add' //--add  //--badge-grey

              dropdownStyle={{
                width: '22rem'
              }}
              options={accountManagerOptions}
              onChange={(event) => {
                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");

                  let payload = {
                    "am": [event],
                  }
                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);
                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)
                    });
                }
              }
              }
            />
          </div>
        )
      }

    },
    {
      title: "Seller Type",
      dataIndex: "Seller Type",
      width: 133,
      key: "Seller Type",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["Seller Type"],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <div className='tag_content--group'><div className='tag_content--grey'>{text}</div></div>}
          </>
        )
      }

    },
    {
      title: "GAM Integration",
      dataIndex: "GAM Integration",
      width: 120,
      key: "GAM Integration",
      hidden: !colvis["GAM Integration"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => <div className='text_dark'>{text}</div>,
    },
    {
      title: "Media Kit",
      width: 80,
      key: "mediaKit",
      hidden: !colvis["Media Kit"],
      render: (_, record) => {
        return (
          record?.Onboarding === 2 && record["Media Kit"]?.length > 0 ?
            <button className='download_icon download_icon_d2'
              onClick={() => {
                fetchAndDownloadFiles(
                  record["Media Kit"],
                  // cell.row.original["title"],
                  // cell.row.original["trackierCampaignId"]
                )

              }}
            ><img src={mediaKitIcon} alt='USP' /></button>
            : <><div className='text_dark'>-</div></>
        )
      }

    },


    {
      title:
        <>

          <span >
            Gross Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :

              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "impressions",
      width: 170,
      key: "impressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["impressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            GIVT Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>

              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "givtImpressions",
      width: 170,
      key: "givtImpressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["givtImpressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtImpsRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            SIVT Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "sivtImpressions",
      width: 170,
      key: "sivtImpressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["sivtImpressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.sivtImpsRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title: <>

        <span >
          IVT
          {columnPartialData ?
            <Tooltip
              title={`Partial Data (${columnTimeData})`}
            >
              <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
            </Tooltip>
            :
            <Tooltip
              title={`Complete Data (${columnTimeData})`}
            >
              <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
            </Tooltip>
          }
        </span>


      </>,
      dataIndex: "givtSivtImp",
      width: 160,
      key: "givtSivtImp",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["givtSivtImp"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtSivtRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            Net Viewability
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>



        </>,
      dataIndex: "viewability",
      width: 150,
      key: "viewability",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["viewability"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)} %
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            Discrepancies
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>

              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>

        </>,
      dataIndex: "discrep",
      width: 150,
      key: "discrep",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["discrep"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
              </>
            }
          </>
        )
      },
    },
    {
      title: "Updated At (UTC)",
      dataIndex: "pix_updatedAt",
      width: 150,
      key: "pix_updatedAt",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["pix_updatedAt"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {data}
              </>
            }
          </>
        )
      },
    },

  ];
  const columnsApproved = [
    {
      title: "Action",
      dataIndex: "Status",
      key: "Status",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      // render: (data) => <div className='badge_content--approved'>{data}</div>,
      fixed: 'left',
      width: 120,
      render: (text, record) => <div className='w_100 position-relative'>
        <Select
          className={`form_select badge_content--${text?.toLowerCase()}`}
          dropdownStyle={{
            width: '12rem'
          }}
          value={text?.toLowerCase()}

          options={
            [{ label: "Declined", value: "declined" }, { label: "Approved", value: "approved" }]
          }
          onChange={(event) => {
            // if (event.toLowerCase() !== text.toLowerCase()) {
            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              let token = Cookies.get("token_xapads_ssp");

              let payload = {
                "status": event,
                "_id": record?._id,
                "approvedOnce": record?.approvedOnce
              }

              setLoading(true)
              axios
                .post(configData.SERVER_URL + `ops/statusUpdate`, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  setApicall(!apiCall)
                  notifysuccess(response.data.message);

                })
                .catch((error) => {
                  if (error.response.data.message?.length !== 0) {
                    notifyfailure(error.response.data.message)
                  }
                  else {
                    notifycatch()
                  }
                  setLoading(false)

                });

            }
            // }
          }
          }
        />
      </div>,

    },

    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      width: 160,
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}

      >{data}</div>,
      // width: 220,
    },

    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 200,
      key: "Organization Name",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      // width: 200,
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sortOrder: sort.name === 'Email' ? sort.type : null,
      render: (data) => <Tooltip title={data}><div className='text_dark text_ellipsis'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      width: 200,
      key: "Website",
      hidden: !colvis["Website"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      // width: 200,
      key: "IM.value",
      hidden: !colvis["IM"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            <img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    {
      title: "Phone Number",
      dataIndex: "Phone Number",
      hidden: !colvis["Phone Number"],
      width: 170,
      key: "Phone Number",
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => {
        return (<>
          {(text === "" || text === undefined || text === null) ? <><div className='text_dark'>-</div></> : <div className='text_dark'>{text}</div>}
        </>
        )
      }

    },
    {
      title: "Country",
      dataIndex: "Country",
      hidden: !colvis["Country"],
      width: 100,
      key: "Country",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text, record) => {
        return (
          <>{
            text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
              <Tooltip title={record.countryName}> <div><img src={text} alt={text} className="flag_icon" /></div></Tooltip>
          }
          </>
        )
      },
    },
    {
      title: "Zones",
      dataIndex: "zone",
      width: 80,
      key: "zone",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvis["zone"],
      // sorter: true,
      render: (data, record) => <div className='text_dark'>
        {record.Status === "Approved" && data === 0 ?

          <Link className="zero_value_design2" style={{ textDecoration: "none", cursor: "default" }} >{data}</Link> :
          record.Status === "Approved" && data !== 0 ?
            <Link to={`/zoneList?publisher=${record["ADK ID"]}-${record["Name"]}`} target="_blank" className='text_primary back_area_increase_d2'>{data}</Link>
            : <></>}
      </div>,
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      key: "AM",
      hidden: !colvis["AM"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      // width: 150,
      render: (text, record) => {
        let data = Array.isArray(text) ? text?.length > 0 ? text[0] : "" : ""
        return (
          <div className='w_100 position-relative'>
            <Select
              value={data}
              className={data === "" ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              // className='form_select tag_content--add' //--add  //--badge-grey

              dropdownStyle={{
                width: '22rem'
              }}
              options={accountManagerOptions}
              onChange={(event) => {

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");

                  let payload = {
                    "am": [event],
                  }

                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);

                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)

                    });

                }
              }
              }
            />
          </div>
        )
      }

    },
    {
      title: "Seller Type",
      dataIndex: "Seller Type",
      hidden: !colvis["Seller Type"],
      width: 133,
      key: "Seller Type",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,

      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <div className='tag_content--group'><div className='tag_content--grey'>{text}</div></div>}
          </>
        )
      }

    },
    {
      title: "GAM Integration",
      dataIndex: "GAM Integration",
      hidden: !colvis["GAM Integration"],
      width: 120,
      key: "GAM Integration",
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => <div className='text_dark'>{text}</div>,
    },

    {
      title: "Media Kit",
      width: 80,
      key: "mediaKit",
      hidden: !colvis["Media Kit"],
      render: (_, record) => {
        return (
          record?.Onboarding === 2 && record["Media Kit"]?.length > 0 ?
            <button className='download_icon download_icon_d2'
              onClick={() => {
                fetchAndDownloadFiles(
                  record["Media Kit"],
                  // cell.row.original["title"],
                  // cell.row.original["trackierCampaignId"]
                )

              }}
            ><img src={mediaKitIcon} alt='USP' /></button>
            : <><div className='text_dark'>-</div></>
        )
      }

    },
    {
      title: "ADK ID",
      dataIndex: "ADK ID",
      hidden: !colvis["ADK ID"],
      width: 90,
      key: "ADK ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "Aniview ID",
      dataIndex: "Aniview ID",
      width: 230,
      key: "Aniview ID",
      hidden: !colvis["Aniview ID"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text, record) => {
        return (
          <>
            {(text === "" || text === null || text === undefined) && record.Status === "Approved" ?
              <>
                <div className='text_dark'>
                  {record?.aniviewLoading ?

                    <button className="new_integrate_btn_d2 btn btn_primary loader loader_btn_with_icon">
                      <span> Integrate</span>
                      <img src={FullLoader} alt="USP" className="" />
                    </button>
                    :
                    <button className="new_integrate_btn_d2" onClick={() => { handleAniviewIdCreate(record) }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M7.5 5L10 7.5L7.5 10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2 2V5.5C2 6.03043 2.21071 6.53914 2.58579 6.91421C2.96086 7.28929 3.46957 7.5 4 7.5H10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Integrate
                    </button>
                  }
                </div>
              </>
              :
              (text === "" || text === null || text === undefined) && record.Status !== "Approved" ?
                <><div className='text_dark'>-</div></>
                :
                <>
                  {text}
                </>}
          </>
        )
      }
    },
    {
      title: "GAM ID",
      dataIndex: "GAM ID",
      width: 120,
      key: "GAM ID",
      hidden: !colvis["GAM ID"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },


    {
      title:
        <>

          <span >
            Gross Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :

              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "impressions",
      width: 170,
      key: "impressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["impressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            GIVT Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>

              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "givtImpressions",
      width: 170,
      key: "givtImpressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["givtImpressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtImpsRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            SIVT Ad Count
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>


        </>,
      dataIndex: "sivtImpressions",
      width: 170,
      key: "sivtImpressions",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["sivtImpressions"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.sivtImpsRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title: <>

        <span >
          IVT
          {columnPartialData ?
            <Tooltip
              title={`Partial Data (${columnTimeData})`}
            >
              <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
            </Tooltip>
            :
            <Tooltip
              title={`Complete Data (${columnTimeData})`}
            >
              <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
            </Tooltip>
          }
        </span>


      </>,
      dataIndex: "givtSivtImp",
      width: 160,
      key: "givtSivtImp",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["givtSivtImp"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtSivtRate)}%)</span>}
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            Net Viewability
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>



        </>,
      dataIndex: "viewability",
      width: 150,
      key: "viewability",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["viewability"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {addCommasToNumber(data)} %
              </>
            }
          </>
        )
      },
    },
    {
      title:
        <>

          <span >
            Discrepancies
            {columnPartialData ?
              <Tooltip
                title={`Partial Data (${columnTimeData})`}
              >
                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>

              :
              <Tooltip
                title={`Complete Data (${columnTimeData})`}
              >
                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
              </Tooltip>
            }
          </span>

        </>,
      dataIndex: "discrep",
      width: 150,
      key: "discrep",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["discrep"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
              </>
            }
          </>
        )
      },
    },
    {
      title: "Updated At (UTC)",
      dataIndex: "pix_updatedAt",
      width: 150,
      key: "pix_updatedAt",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvis["pix_updatedAt"],
      render: (data, record) => {
        return (
          <>
            {(data === "" || data === undefined || data === null) ?
              <>
                <div className='text_dark'>-</div>
              </>
              :
              <>
                {data}
              </>
            }
          </>
        )
      },
    },

  ];

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [initialLoad, setInitialLoad] = useState(true)
  const [tabLoad, setTabLoad] = useState(false)

  const [accountManagerOptions, setAccountManagerOptions] = useState([])


  const [page, setPage] = useState({
    current: 1,
    pageSize: 50,
    total: 10,
  });

  const [sort, setSort] = useState({
    name: "",
    type: ""
  });

  const [search, setSearch] = useState("")
  const [filter, setFilter] = useState("all")




  const getData = () => {
    // setLoading(true)
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      axios
        .get(configData.SERVER_URL + `ops/pubList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}&filter=${filter}`, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          setData(response.data.data.data)
          if (response.data.data.data.length > 0) {
            let tempPage = { ...page }
            tempPage.total = response.data.data.metaData?.totalRecords

            setPage(tempPage)
          }

          // setTimeout(() => {
          //   setLoading(false)
          // }, 300)

          setColumnPartialData(response.data.partial)
          setColumnTimeData(response.data.pix_updatedAt)

          setLoading(false)
          setTabLoad(false)
          setInitialLoad(false)
        })
        .catch((error) => {
          setData([])

          setColumnPartialData(false)
          setColumnTimeData("")

          setLoading(false)
          setTabLoad(false)
          setInitialLoad(false)
        });
    }

  }

  // Function to convert JSON to CSV
  const convertToCSV = (data, headers) => {
    const csvRows = [];
    // Create header row
    const headerRow = headers.map(header => header.label).join(",");
    csvRows.push(headerRow);
    // Create data rows
    data.forEach(row => {
      const rowData = headers.map(header => {
        let value = row[header.key] ?? ""; // Use empty string if value is undefined/null
        if (header.key === "IM") {
          if (Object.keys(value).length > 0) {
            value = `${value.label} (${value.value})`
          }

        }

        if (header.key === "Phone Number") {
          if (value !== undefined) {
            value = value?.replace("-", "")
          }
        }

        if (header.key === "givtImpressions") {
          const givtImpsRate = row["givtImpsRate"] ?? 0; // Default to 0 if undefined
          if (value !== "0") {
            value = `${value} (${givtImpsRate}%)`;
          }
        }

        if (header.key === "sivtImpressions") {
          const sivtImpsRate = row["sivtImpsRate"] ?? 0; // Default to 0 if undefined
          if (value !== "0") {
            value = `${value} (${sivtImpsRate}%)`;
          }
        }

        if (header.key === "givtSivtImp") {
          const givtSivtRate = row["givtSivtRate"] ?? 0; // Default to 0 if undefined
          if (value !== "0") {
            value = `${value} (${givtSivtRate}%)`;
          }
        }

        if (header.key === "viewability") {
          if (value !== undefined) {
            value = `${value}% `
          }
        }

        if (header.key === "AM") {
          if (value !== undefined) {
            if (value.length > 0) {
              value = value.join(",")
            }
            else {
              value = ""
            }

          }
        }

        if (header.key === "Country") {
          value = row["countryName"]
        }

        return `"${String(value).replace(/"/g, '""')}"`; // Escape double quotes
      });
      csvRows.push(rowData.join(","));
    });
    return csvRows.join("\n");
  };

  const getDataExport = () => {
    setExportLoading(true)
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      axios
        .get(configData.SERVER_URL + `ops/pubList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=100000&page=1&filter=all`, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          const keptArray = exportHeader.filter(item => colvis[item.key] !== false);
          const formattedCSV = convertToCSV(response.data.data.data, keptArray);

          // Convert to blob and download
          const blob = new Blob([formattedCSV], { type: "text/csv;charset=utf-8;" });
          saveAs(blob, "Publishers_" + new Date().getTime() + ".csv");
          setExportLoading(false)
        })
        .catch((error) => {
          notifyfailure("Failed to export zone list");
          setExportLoading(false)
        });
    }
  }

  useEffect(() => {
    TokenVerificationLoggedin();
    BlockAdmin()
    // getData()
    loadingContext.done()
  }, [loadingContext]);

  useEffect(() => {
    axios
      .get(configData.SERVER_URL + "ops/p_manager", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setAccountManagerOptions(response.data.data);
      })
      .catch((error) => { });
  }, [])

  useEffect(() => {
    // if (!initialLoad) {
    getData()
    // }
  }, [apiCall])

  useEffect(() => {
    if (!initialLoad) {
      const delayDebounceFn = setTimeout(() => {
        setLoading(true)
        let tempPage = page
        tempPage.current = 1
        setPage(tempPage);
        setApicall(!apiCall)
      }, 400); // 500ms delay
      // Cleanup function to clear the timeout if query changes
      return () => clearTimeout(delayDebounceFn);
    }
  }, [search]);


  function handleTabChange(event) {
    let data = event.target.value
    if (filter !== event.target.value) {
      setTabLoad(true)
    }
    setFilter(data)
    let tempPage = page
    tempPage.current = 1
    tempPage.total = 10
    setPage(tempPage)

    // setPage({
    //   current: 1,
    //   pageSize: 10,
    //   total: 10,
    // })
    setSearch("")
    setSort({
      name: "",
      type: ""
    })

    resetSorter()

    setApicall(!apiCall)



    // if(data==="all"){
    //   setTableColumns(columnsAll)
    // }
    // else if(data==="new"){
    //   setTableColumns(columnsNew)
    // }
    // else if(data==="verified"){
    //   setTableColumns(columnsVerified)
    // }
    // else if(data==="approved"){
    //   setTableColumns(columnsApproved)
    // }


  }

  const resetSorter = () => {
    setTimeout(() => {
      document.querySelectorAll('th[aria-sort]').forEach(th => {
        th.removeAttribute('aria-sort');
      });

      document.querySelectorAll('span[aria-label="caret-up"]').forEach(span => {
        span.classList.remove('active');
      });

      document.querySelectorAll('span[aria-label="caret-down"]').forEach(span => {
        span.classList.remove('active');
      });

    }, 0);

  };

  const handleAniviewIdCreate = (record) => {
    setData(prevData =>
      prevData.map(obj => {
        if (obj["ADK ID"] === record["ADK ID"]) {
          return { ...obj, aniviewLoading: true };
        }
        return obj;
      })
    );

    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp")

      axios
        .post(configData.SERVER_URL + "ops/createAniviewPub?_id=" + record._id, {},
          {
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
          }
        )
        .then((response) => {

          notifysuccess(response.data.message)
          setData(prevData =>
            prevData.map(obj => {
              if (obj["ADK ID"] === record["ADK ID"]) {
                const { aniviewLoading, ...rest } = obj; // Destructure to exclude `aniviewLoading`
                return { ...rest, "Aniview ID": response.data.data };
              }
              return obj;
            })
          );

        })
        .catch((error) => {
          if (error?.response) {
            if (error?.response?.data?.message?.length !== 0) {
              notifyfailure(error.response.data.message)
            }
          } else {
            notifycatch()
          }

          setData(prevData =>
            prevData.map(obj => {
              if (obj["ADK ID"] === record["ADK ID"]) {
                const { aniviewLoading, ...rest } = obj; // Destructure to exclude `aniviewLoading`
                return rest
              }
              return obj;
            })
          );

        });
    }

  }

  const handleTableChange = (pagination, filters, sorter) => {
    // const pager = { ...page };
    // pager.current = pagination.current;
    // setPage(pager);
    // let order;
    // if (sort.name === sorter.field) {
    //   order = sort.type === 'ascend' ? 'descend' : 'ascend';
    // } else {
    //   order = 'ascend';
    // }
    setSort({ name: sorter.field, type: sorter.order });
    // fetchData({
    //   sortField: sorter.field,
    //   sortOrder: sorter.order,
    //   pagination: pager,
    //   ...filters,
    // });
    setApicall(!apiCall)
    setLoading(true)
  };

  const fetchAndDownloadFiles = async (urls) => {

    let name = 1

    try {
      const zip = new JSZip();
      const promises = urls.map(async (ob, index) => {
        try {
          // const response = await fetch(ob?.url);
          const response = await fetch("https://unified-supply-platform.s3.ap-south-1.amazonaws.com/mediaKit/1720698869515-file_example_PPT_1MB.ppt")


          if (!response.ok) {
            throw new Error(`Failed to fetch ${ob?.url}: ${response.statusText}`);
          }
          const blob = await response.blob();

          // Assuming the filename is extracted from the URL or provided in some way
          // const filename = name +"."+ response.headers.get("Content-type").split("/")[1] ;
          // name++;

          zip.file(ob.fileName + "." + ob?.ext, blob);
        } catch (error) {
          console.error("Error fetching file:", error);
        }
      });

      await Promise.all(promises);

      const zipBlob = await zip.generateAsync({ type: "blob" });
      FileSaver.saveAs(zipBlob, "attachments.zip");
      // setIsLoadingInner(false);
      notifysuccess("Media kit downloaded successfully");
    } catch (error) {
      notifyfailure("Error while fetching the media kit.");
      // setIsLoadingInner(false);
    }
  };


  function statusChange(statusFlag, id, approveFlag) {


    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");

      let payload = {
        "status": statusFlag,
        "_id": id,
        "approvedOnce": approveFlag
      }

      setLoading(true)
      axios
        .post(configData.SERVER_URL + `ops/statusUpdate`, payload, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          setApicall(!apiCall)
          notifysuccess(response.data.message);

        })
        .catch((error) => {
          if (error.response.data.message?.length !== 0) {
            notifyfailure(error.response.data.message)
          }
          else {
            notifycatch()
          }
          setLoading(false)

        });

    }
  }

  const handlePageView = (data) => {
    setPageView(data)

  }

  const handlePageViewForEdit = (data, reload) => {
    if (reload === "yes") {
      setApicall(!apiCall)
    }
    setPublisherViewId("")
    setPublisherViewName("")
    setAccountStatus("")
    setPageView(data)
  }


  const handlePageChange = (data) => {

    let tempPage = page
    tempPage.current = data
    setPage(tempPage);
    setApicall(!apiCall)
    setLoading(true)
  };

  const handlePageSizeChange = (e) => {
    let tempPage = page
    tempPage.pageSize = e

    if (tempPage.current > 1) {
      if (e * tempPage.current > tempPage.total) {
        tempPage.current = 1
      }
    }
    setPage(tempPage);
    setApicall(!apiCall)
    setLoading(true)
  };

  const itemRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return <Link><img src={prevIcon} alt='USP' /></Link>;
    }
    if (type === 'next') {
      return <Link><img src={nextIcon} alt='USP' /></Link>;
    }
    return originalElement;
  };


  const locale = {
    emptyText:
      <>{search.trim().length > 0 && loading ?
        <div className='no_data_screen'>
          <div className='text-center'>
            {/* <img src={errorData} className='' alt="" /> */}
            <div className='float_text_div'>
              {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
               <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
            </div>
          </div>
        </div>
        :
        search.trim().length > 0 && !loading ?
          <div className='no_data_screen'>
            <div className='text-center'>
              <img src={errorData} className='' alt="" />
              <div className='float_text_div'>
                {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
              </div>
            </div>
          </div>
          :

          loading ?
            <div className='no_data_screen'>
              <div className='text-center'>
                {/* <img src={errorData} className='' alt="" /> */}
                <div className='float_text_div'>
                  {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                  <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                </div>
              </div>
            </div>
            :
            <div className='no_data_screen' >
              <div className='text-center'>
                <img src={noData} className='' alt="" />
                <div className='float_text_div'>
                  {/* <h1 className='no_data_heading'>Whoops! Looks like there’s no data.</h1>
                  <p className='no_data_para'>There are no records to show you right <br /> now.</p> */}
                </div>
              </div>
            </div>
      }
      </>

  };

  const components = {
    header: {
      wrapper: (props) => (
        <thead {...props}>
          {/* <tr>
                    <th colSpan={columnsAll.length} style={{ textAlign: 'center', background: '#fafafa' }}>
                        Custom Header
                    </th>
                </tr> */}
          {props.children}
        </thead>
      ),
    },

    body: {
      wrapper: (props) => (
        <tbody {...props}>
          {loading ? (
            <>
              <div className='loader_top_space'>
                <div className="inside_table_two_loader">
                  {/* <ContentLoader
                  speed={1}
                  width={1750}
                  height={156}
                  viewBox="-20 0 1806 156"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#e8ecf2"
                >
                  <rect x="0" y="0" rx="6" ry="6" width="85" height="12" />
                  <rect x="1132" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="955" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="1272" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="1411" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="1552" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="1692" y="0" rx="6" ry="6" width="114" height="12" />
                  <rect x="152" y="0" rx="6" ry="6" width="271" height="12" />
                  <rect x="539" y="0" rx="6" ry="6" width="271" height="12" />
                  <rect x="0" y="48" rx="6" ry="6" width="85" height="12" />
                  <rect x="1132" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="955" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="1272" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="1411" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="1552" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="1692" y="48" rx="6" ry="6" width="114" height="12" />
                  <rect x="152" y="48" rx="6" ry="6" width="271" height="12" />
                  <rect x="539" y="48" rx="6" ry="6" width="271" height="12" />
                  <rect x="0" y="96" rx="6" ry="6" width="85" height="12" />
                  <rect x="1132" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="955" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="1272" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="1411" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="1552" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="1692" y="96" rx="6" ry="6" width="114" height="12" />
                  <rect x="152" y="96" rx="6" ry="6" width="271" height="12" />
                  <rect x="539" y="96" rx="6" ry="6" width="271" height="12" />
                  <rect x="0" y="144" rx="6" ry="6" width="85" height="12" />
                  <rect x="1132" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="955" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="1272" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="1411" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="1552" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="1692" y="144" rx="6" ry="6" width="114" height="12" />
                  <rect x="152" y="144" rx="6" ry="6" width="271" height="12" />
                  <rect x="539" y="144" rx="6" ry="6" width="271" height="12" />
                </ContentLoader> */}
                  <img src={FullLoader} className="" alt="" />
                </div>
              </div>


            </>
          ) : (
            props.children
          )}
        </tbody>
      ),
    },
  };


  return (
    <>

      <div className="container_box--wrapper pt_header"
        style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
      >
        <div className="container_box--wrapper--title d_flex justify-content-between">
          <h1 className="heading fw_600"> Publisher List </h1>

          {!initialLoad &&
            <button className='btn btn_primary w_fit_content md'
              onClick={() => { setPageView("import") }}
            ><span><img src={importIcon} alt='USP' /> Import</span></button>
          }

        </div>
        <div className="d_flex justify_content_between w_100 mb_10">
          {!initialLoad &&
            <div className="w-50">
              <Radio.Group
                className='radio_btn--group mb-0'
                value={filter}
                onChange={handleTabChange}>
                <Radio.Button value="all">All</Radio.Button>
                <Radio.Button value="new">New</Radio.Button>
                <Radio.Button value="verified">Verified</Radio.Button>
                <Radio.Button value="approved">Approved</Radio.Button>
              </Radio.Group>
            </div>
          }
          <div className="form_content_block--group w-50 justify-content-end d_flex mb-0">
            {!initialLoad &&

              <Input
                type='text'
                className='form_control basic md search_input w_table_search'
                placeholder="Search"
                value={search}
                onChange={(e) => {
                  if (e.target.value.trim().length === 0) {
                    setLoading(true)
                  }
                  setSearch(e.target.value)
                }
                }
              />


            }
          </div>
          {!initialLoad &&
            <div className="custom_filter_design_d2" style={{ marginLeft: "10px" }}>
              {filter === "all" &&
                <div className="export_btn_hover_d2">
                  {data.length === 0 ?
                    <Button
                      className="export_btn_d2"
                    >
                      <img src={mediaKitIcon2} alt='' />
                      Export
                    </Button>
                    :
                    <>
                      {exportLoading ?
                        <Button
                          className="export_btn_d2"
                        >
                          <img
                            src={FullLoader}
                            alt="USP"
                            height={15}
                            width={15}
                            className="loader_icon"
                          />
                          Export
                        </Button>
                        :
                        <Button
                          className="export_btn_d2"
                          onClick={getDataExport}
                        >
                          <img src={mediaKitIcon2} alt='' />
                          Export
                        </Button>
                      }
                    </>
                  }
                </div>
              }
              <div className="column_hide_unhide_d2">
                <Dropdown className="" autoClose="outside">
                  <Dropdown.Toggle id="dropdown-autoclose-outside">
                    <img src={columnIcon} alt="" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div className="colunm_checkbox">
                      <ul className="p-0 m-0">
                        {/* <li>
                          <label htmlFor="one">
                            <input className="form-check-input" type="checkbox" id="one"
                              checked
                              disabled

                            /> <span>Name</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="two">
                            <input className="form-check-input" type="checkbox" id="two"
                              checked
                              disabled

                            /> <span>Organization Name</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="three">
                            <input className="form-check-input" type="checkbox" id="three"
                              checked
                              disabled

                            /> <span>Email</span>
                          </label>
                        </li> */}
                        <li>
                          <label htmlFor="fourr">
                            <input className="form-check-input" type="checkbox" id="fourr"
                              checked={colvis["Website"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["Website"] = !tempData["Website"]
                                setColvis(tempData)
                              }}

                            /> <span>Website</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="four">
                            <input className="form-check-input" type="checkbox" id="four"
                              checked={colvis["IM"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["IM"] = !tempData["IM"]
                                setColvis(tempData)
                              }}

                            /> <span>IM</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="five">
                            <input className="form-check-input" type="checkbox" id="five"
                              checked={colvis["Phone Number"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["Phone Number"] = !tempData["Phone Number"]
                                setColvis(tempData)
                              }}

                            /> <span>Phone Number</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="six">
                            <input className="form-check-input" type="checkbox" id="six"
                              checked={colvis["Country"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["Country"] = !tempData["Country"]
                                setColvis(tempData)
                              }}

                            /> <span>Country</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="seven">
                            <input className="form-check-input" type="checkbox" id="seven"
                              checked={colvis["AM"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["AM"] = !tempData["AM"]
                                setColvis(tempData)
                              }}

                            /> <span>AM</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="sevenn">
                            <input className="form-check-input" type="checkbox" id="sevenn"
                              checked={colvis["zone"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["zone"] = !tempData["zone"]
                                setColvis(tempData)
                              }}

                            /> <span>Zones</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="eight">
                            <input className="form-check-input" type="checkbox" id="eight"
                              checked={colvis["Seller Type"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["Seller Type"] = !tempData["Seller Type"]
                                setColvis(tempData)
                              }}

                            /> <span>Seller Type</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="nine">
                            <input className="form-check-input" type="checkbox" id="nine"
                              checked={colvis["GAM Integration"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["GAM Integration"] = !tempData["GAM Integration"]
                                setColvis(tempData)
                              }}

                            /> <span>GAM Integration</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="ten">
                            <input className="form-check-input" type="checkbox" id="ten"
                              checked={colvis["Media Kit"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["Media Kit"] = !tempData["Media Kit"]
                                setColvis(tempData)
                              }}

                            /> <span>Media Kit</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="eleven">
                            <input className="form-check-input" type="checkbox" id="eleven"
                              checked={colvis["ADK ID"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["ADK ID"] = !tempData["ADK ID"]
                                setColvis(tempData)
                              }}

                            /> <span>ADK ID</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="twelve">
                            <input className="form-check-input" type="checkbox" id="twelve"
                              checked={colvis["Aniview ID"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["Aniview ID"] = !tempData["Aniview ID"]
                                setColvis(tempData)
                              }}

                            /> <span>Aniview ID</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="thirteen">
                            <input className="form-check-input" type="checkbox" id="thirteen"
                              checked={colvis["GAM ID"]}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData["GAM ID"] = !tempData["GAM ID"]
                                setColvis(tempData)
                              }}

                            /> <span>GAM ID</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="fourteen">
                            <input className="form-check-input" type="checkbox" id="fourteen"
                              checked={colvis.impressions}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData.impressions = !tempData.impressions
                                setColvis(tempData)
                              }}
                            /> <span>Gross Ad Count</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="fifteen">
                            <input className="form-check-input" type="checkbox" id="fifteen"
                              checked={colvis.givtImpressions}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData.givtImpressions = !tempData.givtImpressions
                                setColvis(tempData)
                              }}
                            /> <span>GIVT Ad Count</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="sixteen">
                            <input className="form-check-input" type="checkbox" id="sixteen"
                              checked={colvis.sivtImpressions}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData.sivtImpressions = !tempData.sivtImpressions
                                setColvis(tempData)
                              }}
                            /> <span>SIVT Ad Count</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="seventeen">
                            <input className="form-check-input" type="checkbox" id="seventeen"
                              checked={colvis.givtSivtImp}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData.givtSivtImp = !tempData.givtSivtImp
                                setColvis(tempData)
                              }}
                            /> <span>IVT</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="eighteen">
                            <input className="form-check-input" type="checkbox" id="eighteen"
                              checked={colvis.viewability}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData.viewability = !tempData.viewability
                                setColvis(tempData)
                              }}
                            /> <span>Net Viewability</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="nineteen">
                            <input className="form-check-input" type="checkbox" id="nineteen"
                              checked={colvis.discrep}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData.discrep = !tempData.discrep
                                setColvis(tempData)
                              }}
                            /> <span>Discrepancies</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="twenty">
                            <input className="form-check-input" type="checkbox" id="twenty"
                              checked={colvis.pix_updatedAt}
                              onChange={() => {
                                let tempData = { ...colvis }
                                tempData.pix_updatedAt = !tempData.pix_updatedAt
                                setColvis(tempData)
                              }}
                            /> <span>Updated At</span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          }
        </div>

        <div className="table_content--box no_data_screen_view">
          {loading && !initialLoad &&
            <div className="table_new_loader_d2">
              <img src={FullLoader} className="img-fluid" alt="" />
            </div>
          }
          {initialLoad || tabLoad ?
            <TableLoader />
            :
            <>
              {filter === "all" ?
                <Table
                  columns={columnsAll}
                  pageSize={100}
                  dataSource={data}
                  onChange={handleTableChange}
                  // loading={loading}
                  locale={locale}
                  // components={components}
                  pagination={false}
                  rowKey={(record) => record.id}
                  showSorterTooltip={false}
                  // loadingIndicator={<img src={FullLoader} alt="" />}
                  scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 27rem' }} />

                : filter === "new" ?
                  <Table
                    columns={columnsNew}
                    pageSize={100}
                    dataSource={data}
                    onChange={handleTableChange}
                    showSorterTooltip={false}
                    // loading={loading}
                    locale={locale}
                    // components={components}
                    pagination={false}
                    rowKey={(record) => record.id}
                    scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 27rem' }} />

                  : filter === "verified" ?
                    <Table
                      columns={columnsVerified}
                      pageSize={100}
                      dataSource={data}
                      onChange={handleTableChange}
                      showSorterTooltip={false}
                      // loading={loading}
                      locale={locale}
                      // components={components}
                      pagination={false}
                      rowKey={(record) => record.id}
                      scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 27rem' }} />
                    :
                    <Table
                      columns={columnsApproved}
                      pageSize={100}
                      dataSource={data}
                      onChange={handleTableChange}
                      showSorterTooltip={false}
                      // loading={loading}
                      locale={locale}
                      // components={components}
                      pagination={false}
                      rowKey={(record) => record.id}
                      scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 27rem' }} />
              }
            </>
          }

          {data.length > 0 && !tabLoad &&
            <Row className="custom_pagination--container">
              <Col span={6}>
                <div className="form_content_block--group mb_0">
                  <Select
                    className='form_select basic sm no_search'
                    value={page.pageSize}
                    onChange={handlePageSizeChange}
                    style={{ width: 80 }}
                    showSearch={false}
                    options={[
                      { value: 10, label: 10 },
                      { value: 20, label: 20 },
                      { value: 50, label: 50 },
                      { value: 100, label: 100 },
                    ]} />
                  <label className='custom_pagination--label'>
                    items per page
                  </label>
                </div>
              </Col>
              <Col span={6}>
                <span className="custom_pagination--total-text">
                  {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                </span>
              </Col>
              <Col span={6}>
                <Pagination
                  current={page.current}  // Pass individual props instead of spreading them
                  pageSize={page.pageSize}
                  total={page.total}
                  onChange={handlePageChange}
                  showSizeChanger={false}
                  itemRender={itemRender}
                  className="custom_pagination" />
              </Col>
            </Row>
          }
        </div>
      </div>

      <div
      // style={{ opacity: pageView === "import" ? 1 : 0, display: pageView === "import" ? "block" : "none" }}
      >
        {pageView === "import" &&
          <PublisherImport handlePageViewChange={handlePageView} />
        }
        {pageView === "view" &&
          <PublisherViewEdit handlePageViewChange={handlePageViewForEdit} id={publisherViewId} accountStatus={accountStatus} publisherViewName={publisherViewName} />
        }
      </div>

    </>
  );
};

export default PublisherListing;
